export class SpacerWidgetData {
  height?: number = 100;
}
